import React, { useState, useEffect, useContext } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import "./hrMeetings.css";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosShareAlt } from "react-icons/io";

// ---------------------------------------------------------------------HTTP Methods--------------------------------------------------------------------------------
import { GET, DELETE } from "../../../Common/HttpMethods/HttpMethods";
import { Url } from "../../../../constants/ApiUrlConstants";
// ---------------------------------------------------------------------Context Data--------------------------------------------------------------------------------
import { contextData } from '../../../../context/ContextProvider'

// ---------------------------------------------------------------------React Icons--------------------------------------------------------------------------------
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import SuccessModal from "../../../Common/Popups/SuccessModal";
import FailModal from "../../../Common/Popups/FailModal";
import { BsDownload } from 'react-icons/bs'
import { GeneratePDF, firstLineTextFromHtml, FacilityTableRow, getColumns, getAllToFromOptionalEmailArr, Cuurent_RBAC_roles, Cuurent_EMAIL } from "../../../CommonCase/CommonFunctions";



// src/utils/meetingFunctions.js

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleSessionExpClose = (navigate,setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleCloseSuccessModal = (setOpenSuccessModal) => {
  setOpenSuccessModal(false);
}

export const handleEditPast = (navigate,id) => {
  navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
}

export const handleDeleteMeeting = async ({
  meetingIdToDelete,
  setOpenWarningModal,
  setLoading,
  DELETE,
  Url,
  token2,
  getMeetingData,
  selectedFromDate,
  selectedToDate,
  setData,
  setDataCopy,
  setFailMessage,
  setSessionExpiredModal,
  setOpenFailModal,
  setSuccessMessage,
  setOpenSuccessModal,
}) => {
  setOpenWarningModal(false);
  try {
    setLoading(true);
    const deleteMeetingResp = await DELETE(
      Url.deleteMeeting.replace("{mid}", `${meetingIdToDelete}`),
      token2
    );
    if (deleteMeetingResp.SUCCESS) {
      getMeetingData({
        selectedFromDate,
        selectedToDate,
        setLoading,
        setData,
        setDataCopy,
        setFailMessage,
        setSessionExpiredModal,
        setOpenFailModal,
        token2,
      });
      setLoading(false);
      setSuccessMessage("Meeting deleted successfully.");
      setOpenSuccessModal(true);
    } else if (deleteMeetingResp?.STATUS === 401) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    } else if (deleteMeetingResp?.STATUS === 400) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 403) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 404) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (deleteMeetingResp?.STATUS === 500) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else {
      setLoading(false);
      setFailMessage("Failed to delete meeting.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to delete meeting.");
    setOpenFailModal(true);
  }
};


export const getMeetingData = async ({
  selectedFromDate,
  selectedToDate,
  setLoading,
  setData,
  setDataCopy,
  setFailMessage,
  setSessionExpiredModal,
  setOpenFailModal,
  token2,
}) => {
  try {
    setLoading(true);

    let fromDate = moment(selectedFromDate).format('YYYY-MM-DD');
    let toDate = moment(selectedToDate).format('YYYY-MM-DD');

    const meetingResponse = await GET(
      Url.getMeetingsByTagAndRec
        .replace("{startDate}", `${fromDate}`)
        .replace("{endDate}", `${toDate}`)
        .replace("{deptTagId}", "1"),
      token2
    );

    if (meetingResponse.SUCCESS) {
      const IndexedData = meetingResponse?.DATA?.scheduleMeeting.map((i, ind) => {
        return { ...i, index: ind + 1 };
      });

      setData(IndexedData);
      setDataCopy(IndexedData);
      setLoading(false);
    } else if (meetingResponse.STATUS === 401) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }else if (meetingResponse.STATUS === 400) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }
    else if (meetingResponse.STATUS === 403) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }
    else if (meetingResponse.STATUS === 404) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    }
    else if (meetingResponse.STATUS === 500) {
      setLoading(false);
      setFailMessage("Session expired");
      setSessionExpiredModal(true);
    } else {
      setLoading(false);
      setFailMessage("Failed to fetch meetings.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to fetch meetings.");
    setOpenFailModal(true);
  }
};

export var usermail2 = Cuurent_EMAIL();


export const handleEditAccess = (props, navigate) => {
  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);

  if (allEmailIdArr?.includes(usermail2)) {
    handleEditPast(navigate, props?.mid);
  }

}

const HrMeetings = ({ selectedToDate, selectedFromDate, tableIcons, searchInp, selectedPeriod }) => {
  const token2 = sessionStorage.getItem("TOKEN");
  let rrbac = Cuurent_RBAC_roles();
  const theme = createTheme();
  const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);
 
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)

  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage2, setFailMessage] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  // rbac roles
  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const navigate = useNavigate();

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Meetings Summary");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);
  // ---------------------------------------------------------------------------Popup End-------------------------------------------------------------------------

  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [meetingIdToDelete, setMeetingIdToDelete] = useState(null);

  useEffect(() => {
    if (selectedFromDate && selectedToDate) {
      // Pass the necessary dependencies to the function
      getMeetingData({
        selectedFromDate,
        selectedToDate,
        setLoading,
        setData,
        setDataCopy,
        setFailMessage,
        setSessionExpiredModal,
        setOpenFailModal,
        token2,
      });
    }
  }, [selectedFromDate, selectedToDate]);

  useEffect(() => {
    handleSearch(searchInp);
  }, [searchInp]);

  const handleSearch = (inp) => {

    setData(dataCopy?.filter((i) => {
      return i?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
    })
    )
  };




  ;

  useEffect(() => {
    const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
    [...text][0].innerHTML = "Show Entries";
    [...text][0].style.fontSize = "12px";
  }, [])

 

  const titleStyle = {
    borderRight: '1px solid gray',
  }

  const dataStyle = {
    borderRight: '1px solid gray',
    // fontWeight: "600",
    // color: "black",
  }

  const headStyle = {
    borderRight: "1px solid #b8b8b8",
    padding: "0px 6px",
    whiteSpace: "nowrap"
  }

  const Hr_backgroundColor = "#6E0095";

  const DeptType = "Hr";

  const columns = getColumns(headStyle, titleStyle, dataStyle, usermail2, rbac, setViewPastMeeting, handleEditAccess, Hr_backgroundColor, DeptType, navigate);




  const tableHeaderStyle = {
    backgroundColor: "#F6E6FC",
    color: "#700098",
    fontWeight: "bold",
    height: 20,
  };


  return (
    <div className="hr-table-container" style={{ marginTop: "10px" }}>
      <ThemeProvider theme={theme}>
        <MaterialTable
          localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
          data={data}
          columns={columns}
          icons={tableIcons}
          options={{
            toolbar: false,
            search: false,
            draggable: false,
            pageSizeOptions: [5, 10, 15, 20],
            pageSize: 10,
            headerStyle: {
              position: "sticky",
              top: -1,
              ...tableHeaderStyle,
            },
            maxBodyHeight: '57vh',
            minBodyHeight: '57vh'
          }}
        />
      </ThemeProvider>
      {/* ---------------------------------------------------------------------------Popups--------------------------------------------------------------------------------- */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>handleCloseSuccessModal(setOpenSuccessModal)}
        recallFunctiononClose={()=>handleCloseSuccessModal(setOpenSuccessModal)}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage2={failMessage2}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />
      {/* warning modal */}
      <FailModal
        openFailModal={openWarningModal}
        setOpenFailModal={setOpenWarningModal}
        failMessage2={failMessage2}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() =>
          handleDeleteMeeting({
            meetingIdToDelete,
            setOpenWarningModal,
            setLoading,
            DELETE,
            Url,
            token2,
            getMeetingData,
            selectedFromDate,
            selectedToDate,
            setData,
            setDataCopy,
            setFailMessage,
            setSessionExpiredModal,
            setOpenFailModal,
            setSuccessMessage,
            setOpenSuccessModal
          })
        }
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />

      {/* session expire modal */}
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage2={failMessage2}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive)}
        recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive)}
      />
    </div>
  );
};

export default HrMeetings;
